'use strict'

require './desktop'
PageApplication = require '../../modules/page/frontend/application'
BrowseApplication = require '../../modules/browse/frontend/application'

PageApplication.initialize()
BrowseApplication.initialize()
